module.exports = __webpack_public_path__ + "img/A - 04.1d856d0d.png";